export default "__VITE_ASSET__693b1206__"